





































































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {ExpensePaymentType, PickingListCostType} from '@/enums/type';
import {LadingStatus, PickingListCostStatus} from "@/enums/status";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {PickingListCostStore} from "@/modules/pickinglistcost";
import {BillLadingFeeType} from "@/enums/type/billladingfeetype";

@Component({
    name: "PLCostPrint",
  computed: {
    PickingListCostType() {
      return PickingListCostType
    }
  },
    components: {LadingStatusLabel},
})
export default class extends mixins(CommonMixin) {
    @Prop({required: true, type: Number}) readonly id!: number;
    @Prop({type: Boolean, default: false}) readonly isPrint!: boolean;
    LadingStatus = LadingStatus;
    ExpensePaymentType = ExpensePaymentType;
    BillLadingFeeType = BillLadingFeeType;

    get costBillLadings() {
        return PickingListCostStore.pickingListCostBillLadings;
    }

    get pickingListCost() {
        return PickingListCostStore.data[this.id];
    }

    getMoney(data: any) {
        const fee = this.getProp(data, 'fee');
        return fee !== undefined && fee !== null ? fee : this.getProp(data, 'totalMoney');
    }

    get canDeleteCostBillLading(): boolean {
        return this.pickingListCost?.status === PickingListCostStatus.NotYetPay
    }

    async deleteCostBillLading(costBillLadingId: number) {
        try {
            if (this.costBillLadings.length < 2) {
                this.$message.error('Bảng kê chỉ có 1 vận đơn, vui lòng hủy bảng kê');
                return;
            }
            await PickingListCostStore.deleteBillLadingInPickingListCost({
                pickingListCostId: this.pickingListCost.id,
                costBillLadingId
            })
            this.$message.success("Xóa vận đơn thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Xóa vận đơn thất bại');
        }
    }
}
